import React from 'react';
import { FaSpinner } from 'react-icons/fa';

import { CustomButtom, TamanhoBotao, VarianteBotao } from './styles';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  texto?: string;
  animated?: boolean;
  variante?: VarianteBotao;
  tamanho?: TamanhoBotao;
  icone?: React.ReactNode;
  carregando?: boolean;
  larguraTotal?: boolean;
}

export default function Button({
  texto, animated, variante = 'primario', tamanho = 'md',
  icone, carregando, larguraTotal, disabled, type = 'button', ...rest
}: IProps) {
  return (
    <CustomButtom
      {...rest}
      type={type}
      disabled={disabled || carregando}
      aria-busy={carregando || undefined}
      $animated={animated}
      $variante={variante}
      $tamanho={tamanho}
      $larguraTotal={larguraTotal}
      $soIcone={!texto}
    >
      {carregando ? <FaSpinner className='girando' /> : icone}
      {texto}
    </CustomButtom>
  );
}
